export default __webpack_public_path__ + "static/media/bottom-left.c93309a1.png";